<template>
  <div class="centerCon">
    <el-dialog title="切换工程" :visible.sync="dialogTableVisible">
      <el-table :data="projList">
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="address" label="工程地址"></el-table-column>
        <el-table-column label="设置" width="150">
          <template slot-scope="scope">
            <span class="setProject" @click="toActive(scope.row.id)" v-if="scope.row.active == 0">设为当前工程</span>
            <span class="lookMore" v-if="scope.row.active == 1">当前工程</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <div class="changeText">当前工程：{{ nowPro }}</div>
    <!-- <div class="changePro">切换工程</div> -->
    <el-button class="changePro" type="primary" @click="openProjectSelector" plain>切换工程</el-button>
    <div class="centerTop">
      <div class="line"></div>
      <div class="lineText">全部功能</div>
      <div class="btnCon" v-for="(item, index) in btnList" :key="index" @click="gotoOther(item.key)">
        <div class="imgCon">
          <img class="imgShow" :src="item.imgSrc" alt="" />
        </div>
        <div class="btnText">{{ item.name }}</div>
      </div>
    </div>

    <div class="centerBottom">
      <div class="line"></div>
      <div class="lineText">工程列表</div>
      <div class="engineeringList">
        <EngineeringList></EngineeringList>
      </div>
      <!-- <div class="equipSearchContent">
        <span class="searchInputText">工程名称</span>
        <el-input placeholder="请输入工程名称" v-model="search.projectName"></el-input>
        <span class="searchInputText">异常作业</span>
        <el-select v-model="search.alarmSortType" placeholder="请选择...">
          <el-option
            v-for="item in errorList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button type="danger" @click="doSearch" style="margin-left: 24px"
          >查找</el-button
        >
        <el-button type="info" @click="resetSearchO" plain>重置</el-button>
      </div>

      <div class="equipListInfoShowContent">
        <div class="equipItem" v-for="(item,index) in dataList" :key="index">
          <div class="itemTitle">{{item.name}}</div>
          <div class="itemInfo">
            <div class="item_1">
              <span class="address">{{item.address}}</span>
              <span :class="[item.todayWork?'haveWork':'noWork']">{{item.todayWork?'今日有施工':'今日未施工'}}</span>
            </div>
            <div class="item_2">
              <div class="timeProcess">
                <span class="processT">项目进度：</span>
                <span class="processS">{{item.process}}%</span>
              </div>
              <div class="dayProcess">
                <span class="processT">{{item.remainDay?(item.remainDay>=0?'倒计时：':'已延期：'):'倒计时：'}}</span>
                <span class="processS">{{item.remainDay>=0?item.remainDay:(Math.abs(item.remainDay)) + ' '}}</span>
                <span class="processU">天</span>
              </div>
            </div>
            <div class="item_3">
              <span class="processNum">{{item.timeProcess}}%</span>
              <div class="processShow"></div>
              <div class="processH" :style="{'width': item.timeProcess*1080/100 + 'px'}"></div>
              <span class="startTime">开始日期：{{item.startTime}}</span>
              <span class="endTime">结束日期：{{item.planEndTime}}</span>
            </div>
            <div class="item_4" @click="toProgress(item.id)">查看更多</div>
            <div style="clear:both"></div>
          </div>
          <div class="workContent" v-if="item.works.length> 0">
            <el-carousel indicator-position="outside">
              <el-carousel-item v-for="(i,n) in item.workList" :key="n">
                <div class="workItem">
                  <div class="itemShow" v-for="(j,k) in i" :key="k">
                    <div class="itemImg" :class="[j.working?'haveWork':'']"><div class="itemImgShow"></div></div>
                    <span class="workTitle">{{j.workName}}</span>
                    <span class="workJ">作业进度：{{j.process}}%</span>
                    <span class="workW" :class="[j.hasRecentlyAlarm?'isWarn':'']">{{j.hasRecentlyAlarm?'近7天有报警':'近7天无报警'}}</span>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>

      <el-pageCover
        class="pageBlock"
        :pageMsg="pageMsg"
        @sizeChange="pageSizeChange"
        @currentChange="currentPageChange"
      ></el-pageCover>-->
    </div>
    <!-- <div class="engineeringList">
        <EngineeringList></EngineeringList>
      </div> -->
    <!-- <el-dialog :title="actionNameT" :visible.sync="officeShow" :close-on-click-modal="false" width="400px"
      @selection-change="handleSelectionChange" :row-key="fieldKey">
      <div class="borderBlock borderPadding addAndEdit">
        <el-tree :data="treeList" node-key="id" ref="maskTree" default-expand-all accordion
          :filter-node-method="filterNode" :expand-on-click-node="false" @node-click="handleNodeClickAdd"
          :default-checked-keys="checkedKeys"></el-tree>
      </div>
    </el-dialog> -->
      <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="officeShow = false">取消</el-button>
            <el-button type="primary" @click="editModSubmit">确定</el-button>
        </span> -->
    
  </div>
</template>

<script>
import EngineeringList from "../engineering/engineeringList";
import {
  getEquipTypeList,
  getEnginList as fetchDtList,
  // getOfficeList,
  activeEngin,
  getEnginList,
  getWorks
} from "../../utils/api";
import roleMixin from "../../utils/roleMixin";
import mixinList from "../../utils/mixinList";
// import ElPageCover from "../../components/overall/ElPageCover";
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {
    return {
      dialogTableVisible: false,
      nowPro: '',
      projList: [],
      projectId: '',
      workId: '',
      workName: '',
      search: {
        type: 1,
        pageSize: 5
      },
      arrowList: [
        {
          name: "工程中心",
          path: "/transfer/equipmentCenter",
        },
        {
          name: "",
          path: "/transfer",
        },
      ],
      btnList: [
        // {
        //   name: "前场监控",
        //   key: "Monitor",
        //   imgSrc: require("../../images/icon/c_1.png"),
        // },
        // {
        //   name: "拌合监控",
        //   key: "",
        //   imgSrc: require("../../images/icon/c_1.png"),
        // },
        // {
        //   name: "运输监控",
        //   key: "",
        //   imgSrc: require("../../images/icon/c_1.png"),
        // },
        // {
        //   name: "工程进度",
        //   key: "EngineeringProgress",
        //   imgSrc: require("../../images/icon/c_2.png"),
        // },
        // {
        //   name: "工程日报",
        //   key: "",
        //   imgSrc: require("../../images/icon/c_3.png"),
        // },
        // {
        //   name: "作业质量",
        //   key: "Qualityz",
        //   imgSrc: require("../../images/icon/c_4.png"),
        // },
        {
          name: "作业质量",
          key: "QualityDay",
          imgSrc: require("../../images/icon/c_4.png"),
        },
        // {
        //   name: "工程验收",
        //   key: "Check",
        //   imgSrc: require("../../images/icon/c_5.png"),
        // },
        // {
        //   name: "作业回放",
        //   key: "MonitorRe",
        //   imgSrc: require("../../images/icon/c_6.png"),
        // },
        // {
        //   name: "工程管理",
        //   key: "EngineeringList",
        //   imgSrc: require("../../images/icon/c_7.png"),
        // },
        {
          name: "道路管理",
          key: "RoadList",
          imgSrc: require("../../images/icon/c_7.png"),
        },
      ],
      equipTypeList: [],
      equipStatusList: [
        {
          id: "",
          name: "全部",
        },
        {
          id: 0,
          name: "离线",
        },
        {
          id: 1,
          name: "怠速",
        },
        {
          id: 2,
          name: "作业中",
        },
      ],
      errorList: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: 1,
          name: "异常作业",
        },
        {
          id: 2,
          name: "无异常作业",
        },
      ],
      pageMsg: {
        pageSize: 5,
        pageNo: 1,
        totalRecords: 0,
      },
      loading: "",
      treeList: [],
      actionNameT: "",
      officeShow: false,
      officeSetType: "",
      formShow: "",
      fieldKey: "ids",
      checkedKeys: [],
    };
  },
  watch: {
    dataList: {
      handler(val) {
        console.log(val)
        let that = this
        for (let i = 0; i < val.length; i++) {
          let workList = val[i].works
          let set = []
          let get = []
          for (let n = 0; n < workList.length; n++) {
            get.push(workList[n])
            if ((n > 0 && n % 3 == 0) || n == workList.length - 1) {
              set.push(get)
              get = []
            }
          }
          that.dataList[i].workList = set
        }
        console.log(this.dataList)
      }
    }
  },
  computed: {
    // EngineeringList
  },
  created() { },
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    getEquipTypeList({ pageSize: 100 }).then((res) => {
      let allVal = {
        id: "",
        name: "全部",
      };
      this.equipTypeList = res.data.content.list;
      this.equipTypeList.unshift(allVal);
    });

    this.doSearch();
    this.getProjectList()
    // getOfficeList(this.search).then((res) => {
    //   //console.log(res)
    //   let _arr = res.data.content.concat([]);

    //   let _getDepts = function (list, _depts) {
    //     for (let i = 0; i < list.length; i++) {
    //       let _m = list[i];
    //       _depts.push({
    //         id: _m.officeCode,
    //         label: _m.officeName,
    //         originalData: _m,
    //       });

    //       if (
    //         Object.prototype.hasOwnProperty.call(_m, "children") &&
    //         _m.children.length > 0
    //       ) {
    //         _depts[_depts.length - 1].children = [];
    //         _getDepts(_m.children, _depts[_depts.length - 1].children);
    //       }
    //     }
    //   };
    //   let _depts = [];
    //   _getDepts(_arr, _depts);
    //   this.treeList = _depts;
    // });
  },
  methods: {
    fetchDtList,
    toProgress(e) {
      this.$router.push({ name: 'EngineeringProgress', params: { id: e } });
    },
    resetSearchO() {
      this.search = { pageNum: 1, pageSize: 5, type: 1 }
      let params = this.search;
      this.getDataList(params, { listKey: "list" });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    openProjectSelector() {
      this.dialogTableVisible = true;
      // this.getProjectList();
    },
    toActive(setId) {
      let params = {
        id: setId,
      };
      activeEngin(params).then(() => {
        this.getProjectList();

      });
    },
    getProjectList() {
      getEnginList({ pageSize: 1000 }, { listKey: "list" }).then((res) => {
        this.projList = res.data.content.info.list;
        const currentProject = (this.projList || []).find(
          (item) => item.active == 1
        );
        this.projectId = currentProject.id
        this.nowPro = currentProject.name
        this.$store.commit("setProjectId", this.projectId);
        getWorks({ projectId: this.projectId }).then((res) => {
          this.workId = res.data.content.info.list[0].id;
          this.workName = res.data.content.info.list[0].name;

        });
      });
    },
    doSearch: function () {
      // this.loading = this.$loading({
      //   lock: true,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      //   target: document.querySelector(".centerBottom"),
      // });
      this.getDataList(this.search, { listKey: "list" });
    },
    // 跳转到设备详情
    goToEquipInfo(code, type, tab) {
      this.$router.push({
        name: 'EquipmentInfo', params: {
          'code': code,
          'typeName': type,
          'inArrow': 'equipmentList',
          'index': tab
        }
      })
    },
    goToEquipmentMonitor(code) {
      this.$router.push({
        name: 'EquipmentMonitor', params: {
          'code': code,
        }
      })
    },
    gotoOther: function (e) {
      if (e == '') {
        this.$message({
          message: '该功能暂未开发！',
          type: 'warning'
        });
      } else if (e == 'MonitorRe') {
        this.$router.push({ path: '/transfer/monitorRe', query: { workId: this.workId, workName: this.workName, type: 'RE' } });
      } else {
        this.$router.push({ name: e });
      }

    },
    toEquipmentInfo: function (c, t) {
      this.$router.push({
        name: "EquipmentInfo",
        params: {
          code: c,
          typeName: t,
          inArrow: "equipmentCenter",
        },
      });
    },
    openOffice: function (val) {
      //console.log('111')
      this.actionNameT = "部门选择";
      this.officeShow = true;
      this.officeSetType = val;
      this.formShow = false;
      this.formShow = true;
    },
    handleSelectionChange: function (val) {
      let deleteArr = [];
      for (let i = 0; i < val.length; i++) {
        deleteArr.push(val[i].id);
      }
      this.deleteStr = deleteArr.join(",");
    },
    handleNodeClickAdd(val) {
      //console.log(val)
      var that = this;
      if (this.officeSetType == 1) {
        that.search.officeCode = val.id;
        that.search.officeName = val.label;
      } else {
        // that.officeCode = val.id;
        // that.officeName = val.label;

        that.modelObj.officeName = val.label;
        that.modelObj.officeCode = val.id;
        that.mediaName = "";
        let timer = setTimeout(function () {
          that.$set(that.modelObj, "officeName", val.label + " ");
          that.$set(that.modelObj, "officeCode", val.id + " ");
          clearTimeout(timer);
          // that.officeCode = val.id;
          // that.officeName = val.label;

          // that.modelObj.officeName = val.label;
          // that.modelObj.officeCode = val.id;
        }, 300);
      }
      this.officeShow = false;
      // this.formShow=false;
      // this.formShow=true;
    },
  },
  components: {
    // ElPageCover,
    EngineeringList
  },
};
</script>
<style lang="scss">
.equipSearchContent {
  .el-input {
    width: 180px !important;
    height: 36px !important;
    margin-left: 23px;
    // margin-right: 23px;
    font-size: 14px !important;

    .el-input__inner {
      width: 180px !important;
      height: 36px !important;
      border-radius: 1px !important;
    }
  }

}

.workContent {
  .el-carousel {
    height: 100% !important;
  }

  .el-carousel__container {
    height: 140px;
  }
}
</style>
<style lang="scss" scoped="">
.engineeringList {
  // top: -50px;
  width: 100%;
  height: 500px;
}

.centerCon {
  min-height: 500px;
  width: 1872px;
  border-radius: 2px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  margin: 0 auto;
  position: relative;

  .setProject {
    display: inline-block;
    font-size: 14px;
    color: #555555;
    background: rgba(238, 236, 236, 1);
    border: 1px solid rgba(196, 196, 196, 1);
    border-radius: 16px;
    padding: 4px 16px;
    cursor: pointer;
  }

  .lookMore {
    display: inline-block;
    font-size: 14px;
    color: #e24747;
    background: rgba(255, 232, 232, 1);
    border: 1px solid rgba(226, 71, 71, 1);
    border-radius: 16px;
    padding: 4px 16px;
    margin-left: 10px;
    cursor: pointer;
  }

  .changeText {
    line-height: 28px;
    color: rgba(0, 0, 0, 0.8);
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    right: 112px;
    top: -42px;
    z-index: 500;
  }

  .changePro {
    position: absolute;
    width: 88px;
    height: 32px;
    text-align: center;
    // line-height: 30px;
    font-size: 14px;
    // background: rgba(245, 108, 108, 0.1);
    // border-radius: 2px;
    // border: 1px solid #F56C6C;
    // color: #F56C6C;
    // cursor: pointer;
    right: 0;
    top: -45px;
    z-index: 500;
  }

  .centerTop {
    width: 100%;
    height: 218px;
    position: relative;
    padding: 74px 0 0 0;
    border-bottom: 1px solid #f0f0f0;

    .line {
      height: 18px;
      width: 4px;
      background-color: #f56c6c;
      position: absolute;
      top: 28px;
      left: 24px;
    }

    .lineText {
      height: 26px;
      line-height: 26px;
      font-size: 18px;
      color: #404040;
      position: absolute;
      top: 24px;
      left: 36px;
      font-weight: medium;
    }

    .btnCon {
      width: 128px;
      height: 144px;
      float: left;
      margin-right: 32px;

      .imgCon {
        width: 80px;
        height: 80px;
        border-radius: 4px;
        background: rgba(245, 108, 108, 0.8);
        margin: 0 auto;
        cursor: pointer;

        .imgShow {
          width: 32px;
          height: 32px;
          margin: 24px 24px;
        }
      }
    }

    .btnText {
      height: 24px;
      line-height: 24px;
      width: 100%;
      margin-top: 16px;
      text-align: center;
      font-size: 16px;
      color: #404040;
      cursor: pointer;
    }
  }

  .centerBottom {
    width: 100%;
    min-height: 900px;
    position: relative;
    padding-top: 70px;
    padding-bottom: 24px;

    .line {
      height: 18px;
      width: 4px;
      background-color: #f56c6c;
      position: absolute;
      top: 28px;
      left: 24px;
    }

    .lineText {
      height: 26px;
      line-height: 26px;
      font-size: 18px;
      color: #404040;
      position: absolute;
      top: 24px;
      left: 36px;
      font-weight: medium;
    }

    .equipSearchContent {
      height: 40px;
      width: 100%;
      margin: 0 auto;
      background-color: #ffffff;
      margin-bottom: 16px;

      .searchInputText {
        color: #595959;
        font-size: 14px;
        margin-left: 24px;
      }
    }

    .equipListInfoShowContent {
      width: 100%;
      height: auto;
      padding: 0 24px;

      .equipItem {
        width: 100%;
        height: auto;
        border: 1px solid rgba(0, 0, 0, 0.05);
        margin-bottom: 16px;

        .workContent {
          width: 100%;
          height: 168px;
          border-top: 1px solid rgba(0, 0, 0, 0.05);

          .workItem {
            width: 100%;
            height: 100%;
            display: flex;

            .itemShow {
              width: 25%;
              height: 100%;
              position: relative;

              .workTitle {
                width: 176px;
                display: inline-block;
                line-height: 22px;
                color: #000000;
                opacity: 0.8;
                position: absolute;
                font-size: 16px;
                left: 247px;
                top: 30px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .workJ {
                width: 176px;
                display: inline-block;
                line-height: 20px;
                color: #000000;
                opacity: 0.5;
                position: absolute;
                font-size: 14px;
                left: 247px;
                top: 65px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .workW {
                width: 176px;
                display: inline-block;
                line-height: 20px;
                color: rgba(0, 0, 0, 0.5);
                // opacity: 0.5;
                position: absolute;
                font-size: 14px;
                left: 247px;
                top: 100px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .isWarn {
                width: 100px;
                height: 24px;
                background-color: #f56c6c;
                text-align: center;
                line-height: 24px;
                color: #ffffff;
                border-radius: 3px;
              }

              .itemImg {
                width: 208px;
                height: 117px;
                position: absolute;
                background: rgba(0, 0, 0, 0.05);
                top: 16px;
                left: 24px;
              }

              .haveWork {
                border: 1px solid #6DD400;
              }

              .itemImgShow {
                width: 184px;
                height: 72px;
                background-image: url("../../images/all/workImg.png");
                background-size: 100% 100%;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
              }
            }
          }
        }

        .itemTitle {
          width: 100%;
          height: 56px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          line-height: 56px;
          padding-left: 24px;
          color: #000000;
          font-weight: bold;
          font-size: 16px;
        }

        .itemInfo {
          width: 100%;
          height: 96px;

          .item_1 {
            width: 227px;
            height: 100%;
            float: left;
            position: relative;
            border-right: 1px solid rgba(0, 0, 0, 0.05);

            .haveWork {
              display: inline-block;
              position: absolute;
              width: 88px;
              height: 24px;
              line-height: 24px;
              text-align: center;
              background: #6DD400;
              border-radius: 2px;
              color: #ffffff;
              top: 54px;
              left: 24px;
              font-size: 14px;
            }

            .noWork {
              display: inline-block;
              position: absolute;
              width: 88px;
              height: 24px;
              line-height: 24px;
              text-align: center;
              background: rgba(0, 0, 0, 0.3);
              border-radius: 2px;
              color: #ffffff;
              top: 54px;
              left: 24px;
              font-size: 14px;
            }

            .address {
              display: inline-block;
              position: absolute;
              color: #000000;
              opacity: 0.5;
              font-size: 14px;
              line-height: 20px;
              height: 20px;
              width: 200px;
              top: 20px;
              left: 24px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          .item_2 {
            width: 227px;
            height: 100%;
            float: left;
            position: relative;

            .timeProcess {
              width: 200px;
              height: 28px;
              line-height: 28px;
              position: absolute;
              top: 16px;
              left: 24px;

              .processT {
                font-size: 16px;
                color: #000000;
                opacity: 0.5;
              }

              .processS {
                font-size: 20px;
                color: #000000;
                opacity: 0.8;
              }
            }

            .dayProcess {
              width: 200px;
              height: 28px;
              line-height: 28px;
              position: absolute;
              top: 52px;
              left: 24px;

              .processT {
                font-size: 16px;
                color: #000000;
                opacity: 0.5;
              }

              .processS {
                font-size: 20px;
                color: #000000;
                opacity: 0.8;
              }

              .processU {
                font-size: 16px;
                color: #000000;
                opacity: 0.8;
              }
            }
          }

          .item_3 {
            width: 1139px;
            height: 100%;
            float: left;
            position: relative;
            border-right: 1px solid rgba(0, 0, 0, 0.05);

            .processNum {
              display: inline-block;
              position: absolute;
              height: 20px;
              line-height: 20px;
              color: #000000;
              opacity: 0.8;
              top: 11px;
              left: 50%;
              transform: translateX(-50%);
              font-size: 14px;
            }

            .startTime {
              display: inline-block;
              position: absolute;
              height: 17px;
              line-height: 17px;
              color: #000000;
              opacity: 0.5;
              left: 30px;
              bottom: 16px;
              font-size: 12px;
            }

            .endTime {
              display: inline-block;
              position: absolute;
              height: 17px;
              line-height: 17px;
              color: #000000;
              opacity: 0.5;
              right: 30px;
              bottom: 16px;
              font-size: 12px;
            }

            .processShow {
              position: absolute;
              width: 1080px;
              height: 12px;
              top: 42px;
              left: 30px;
              background: rgba(0, 0, 0, 0.1);
              z-index: 1;
            }

            .processH {
              position: absolute;
              height: 12px;
              top: 42px;
              left: 30px;
              background: #F7B500;
              z-index: 2;
            }
          }

          .item_4 {
            width: 227px;
            height: 100%;
            float: left;
            position: relative;
            line-height: 96px;
            text-align: center;
            color: #F56C6C;
            font-size: 16px;
            cursor: pointer;
            // border-right: 1px solid rgba(0, 0, 0, 0.05);
          }
        }
      }
    }
  }
}

.pageBlock {
  margin-top: 30px;
}</style>